import React, { useState } from "react";
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
  useExpanded,
  useRowSelect,
} from "react-table";
import {
  Table,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
  Button,
  Popover,
} from "@mui/material";
import Empty from "../error/Empty";
import TableFooter from "./sub-components/TableFooter";
import TableHeader from "./sub-components/TableHeader";
import TableFeature from "./sub-components/TableFeature";
import TableCustomizerDialog from "./sub-components/TableCustomizerDialog";
import TableLoader from "../TableLoader";
import { exportData, getExportableData } from "../../manager/dataManager";
import { invoiceDefaultColumn } from "./cell/invoiceTableCustomCell";
import TableFilterPopOver from "./sub-components/TableFilterPopOver";
import TableHeaderLayout from "./sub-components/TableHeaderLayout";
import TableCheckbox from "./sub-components/TableCheckbox";
import { Delete, Description, Download } from "@mui/icons-material";
import Invoiceupdate from "../Invoiceupdatemodal";
import Invoicedelete from "../Invoicedeletemodal";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";

function InvoicesTable({
  columns,
  data,
  fromDate,
  toDate,
  handleFromDate,
  handleToDate,
  callAPI,
  PONumber,
  setPONumber,
  RCPTNumber,
  setRCPTNumber,
  loading,
  expandedTable,
}) {
  const handleDoubleClick = (rowData) => {
    setinvoicedocid(rowData.SupplierInvoiceDocumentsID);
    setinvoiceid(rowData.InvoiceNo);
  };
  const handleDeleteinvoice = (original) => {
    setdeleteinvoicenumber(original.InvoiceNo);
    setdeleteinvoiceid(original.SupplierInvoiceDocumentsID);
  };
  const handlepopover = (POID, invoicenumber, original) => {
    setpopid(POID);
    setpopnumber(invoicenumber);
    setdeleteoriginal(original);
  };
  const handlepopClick = (event) => {
    setAnchorE2(event.currentTarget);
  };
  const handlepopClose = () => {
    setAnchorE2(null);
    setpopid(null);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    pageOptions,
    state,
    setPageSize,
    canPreviousPage,
    setGlobalFilter,
    prepareRow,
    allColumns,
    getToggleHideAllColumnsProps,
    selectedFlatRows,
    gotoPage,
    pageCount,
  } = useTable(
    {
      columns,
      data,
      defaultColumn: invoiceDefaultColumn,
      initialState: {
        pageSize: 12,
        hiddenColumns: columns
          .filter((col) => col.show === false)
          .map((col) => col.accessor),
      },
      getSubRows: (row) => {
        if (row?.subRows) {
          return row?.subRows;
        }
        return [];
      },
      handleDoubleClick,

      handlepopover,
      handlepopClick,
    },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,

    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: "selection",
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <TableCheckbox {...getToggleAllRowsSelectedProps()} />
            ),
            Cell: ({ row }) => (
              <>
                {(row.subRows.length !== 0 || !expandedTable) && (
                  <TableCheckbox {...row.getToggleRowSelectedProps()} />
                )}
              </>
            ),
          },
          ...columns,
        ];
      });
    }
  );

  const { pageIndex, pageSize, globalFilter } = state;
  const [anchorEl, setAnchorEl] = useState(null);
  const [showTableCustomizer, setShowTableCustomizer] = useState(false);
  const [invoiceid, setinvoiceid] = useState(null);
  const [invoicedocid, setinvoicedocid] = useState(null);
  const [deleteinvoiceid, setdeleteinvoiceid] = useState(null);
  const [deleteinvoicenumber, setdeleteinvoicenumber] = useState(null);
  const [popid, setpopid] = useState(null);
  const [popnumber, setpopnumber] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [deleteoriginal, setdeleteoriginal] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <>
      <Popover
        open={Boolean(popid)}
        anchorEl={anchorE2}
        onClose={handlepopClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Typography sx={{ p: 2 }}>
          <div style={{ display: "flex" }}>
            <h1 style={{ fontSize: "14px", paddingRight: "5px" }}>View</h1>
            <Link to={popnumber ? `${popid}?inv=${popnumber}` : `${popid}`}>
              <Description
                fontSize="small"
                style={{ marginLeft: "9px" }}
              ></Description>
            </Link>
          </div>

          <div style={{ display: "flex" }}>
            <h1 style={{ fontSize: "14px", paddingRight: "5px" }}>Delete</h1>
            <Delete
              fontSize="small"
              color="error"
              onClick={() => {
                handleDeleteinvoice(deleteoriginal);
              }}
            />
          </div>
        </Typography>
      </Popover>

      <Invoiceupdate
        InvoiceID={invoiceid}
        Invoicedocid={invoicedocid}
        handleClose={() => {
          setinvoiceid(null);
        }}
      />
      <Invoicedelete
        InvoiceID={deleteinvoiceid}
        Invoicenumber={deleteinvoicenumber}
        handleClose={() => {
          setdeleteinvoicenumber(null);
        }}
        fromDate={fromDate}
        toDate={toDate}
        setpopid={setpopid}
      />
      <TableCustomizerDialog
        open={showTableCustomizer}
        handleClose={() => setShowTableCustomizer(false)}
        allColumns={allColumns}
        getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
      />
      <TableFilterPopOver
        open={open}
        handleClose={handleClose}
        anchorEl={anchorEl}
        fromDate={fromDate}
        toDate={toDate}
        callAPI={callAPI}
        setPONumber={setPONumber}
        PONumber={PONumber}
        RCPTNumber={RCPTNumber}
        setRCPTNumber={setRCPTNumber}
        handleFromDate={handleFromDate}
        handleToDate={handleToDate}
      />
      <TableHeaderLayout
        setGlobalFilter={setGlobalFilter}
        globalFilter={globalFilter}
        fromDate={fromDate}
        toDate={toDate}
      >
        {selectedFlatRows.length === 0 ? (
          <TableFeature
            handleFilter={handleClick}
            openCustomizer={() => setShowTableCustomizer(true)}
            refresh={callAPI}
            exportHandler={() =>
              exportData(
                getExportableData(data, columns),
                `Invoice ${fromDate} to ${toDate}`
              )
            }
            fromDate={fromDate}
            toDate={toDate}
          />
        ) : (
          <Button
            variant="outlined"
            endIcon={<Download sx={{ fontSize: "10px" }} />}
            size="small"
            onClick={() => {
              exportData(
                getExportableData(
                  selectedFlatRows.map((row) => row.original),
                  columns
                ),
                `Invoice ${fromDate} to ${toDate}`
              );
            }}
          >
            Export Selected
          </Button>
        )}
      </TableHeaderLayout>
      {data.length === 0 && loading === false && (
        <Empty title={"No data found"} />
      )}
      {data.length !== 0 && loading === false && (
        <>
          <TableContainer component={Paper}>
            <Table
              {...getTableProps()}
              sx={{
                borderCollapse: "separate",
                minWidth: "max-content",
              }}
            >
              <TableHeader headerGroups={headerGroups} />
              <TableBody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <TableRow
                      {...row.getRowProps()}
                      sx={{
                        "& td": {
                          bgcolor: "background.paper",
                          ...(expandedTable && {
                            bgcolor:
                              row.subRows.length !== 0
                                ? "background.paper"
                                : "#f3f3f3",
                          }),
                          cursor: "pointer",
                        },
                      }}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <TableCell {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TableFooter
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            pageOptions={pageOptions}
            pageIndex={pageIndex}
            nextPage={nextPage}
            previousPage={previousPage}
            setPageSize={setPageSize}
            pageSize={pageSize}
            gotoPage={gotoPage}
            pageCount={pageCount}
          />
        </>
      )}
      {loading === true && <TableLoader title={"Loading..."} />}
    </>
  );
}

export default InvoicesTable;
